import { Trans, useTranslation } from 'next-i18next'

interface ExtraMissingMenusProps {
	count: number
	date: string
}
export const ExtraMissingMenus = ({ count, date }: ExtraMissingMenusProps) => {
	const { t } = useTranslation()

	return (
		<p
			data-testid='missing-menus-msg'
			className='text-sm'
		>
			<Trans
				i18nKey='extras:menus.missing.label'
				values={{ count, date }}
			/>

			<br />

			{t('extras:menus.missing.subtitle')}
		</p>
	)
}
